import { createRouteForPath } from '@/utils/helpers/urlHelper'

export const pageUrl = {
  main: '/',
  home: createRouteForPath('/'),
  signIn: '/sign-in',
  signUp: '/sign-up',
  onboarding: '/onboarding',
  onboardingStep: '/onboarding/:step',
  settings: '/settings',
  settingsBranch: createRouteForPath('/settings'),
  accountProfile: '/accounts/profiles',
  accountPasswordSecurity: '/accounts/password-security',
  pushNotification: '/accounts/push-notification',
  settingsPaymentTypes: '/settings/payment-types',
  settingsServiceCharges: '/settings/service-charges',
  settingsReceivePayment: '/settings/receive-payment',
  settingsPrinter: '/settings/printer',
  settingsTaxes: '/settings/taxes',
  calendar: createRouteForPath('/calendar'),
  engagement: '/Engage',
  reports: '/reports',
  services: createRouteForPath('/services'),
  bundles: createRouteForPath('/bundles'),
  packages: createRouteForPath('/packages'),
  products: createRouteForPath('/products'),
  vouchers: createRouteForPath('/vouchers'),
  servicesAdd: createRouteForPath('/services/add'),
  servicesEdit: createRouteForPath('/services/:id'),
  client: createRouteForPath('/clients'),
  clientLoyaltyPoints: '/clients-loyalty-points',
  clientLoyaltyTiers: '/clients-loyalty-tiers',
  clientAdd: '/clients/add',
  clientReviews: '/clients/reviews',
  clientAutomatedMessages: '/clients/automated-messages',
  sales: createRouteForPath('/sales'),
  salesAll: createRouteForPath('/sales/all'),
  teams: createRouteForPath('/teams/users'),
  teamsInviteUser: '/teams/invite-user',
  teamsSchedule: createRouteForPath('/teams/schedule'),
  branch: '/branches',
  branchSetting: '/branches/setting',
  invitation: '/invitation/:token',
  role: createRouteForPath('/teams/roles'),
  setupProfile: '/setup-profile',
  reportTips: createRouteForPath('/reports/tips'),
  salesLog: createRouteForPath('/reports/sales-log'),
  reportTipsDetail: createRouteForPath('/reports/tips/:id'),
  reportComissions: createRouteForPath('/reports/comissions'),
  resetPassword: '/reset-password/:id',
  error498: '/error/498',
  error403: '/error/403',
  error402: '/error/402',
  deals: createRouteForPath('/deals'),
  bookingWebsite: '/settings/booking-website',
  settingBlockedTime: '/settings/blocked-times',
  financeSummary: createRouteForPath('/finance-summary'),
  reportPerformance: createRouteForPath('/reports/performance'),
  webEditor: '/editor',
  billing: createRouteForPath('/billings'),
  notifications: createRouteForPath('/notifications'),
  expenses: createRouteForPath('/expenses'),
  payments: createRouteForPath('/payments'),
  rating: 'rating/:id',
  auditLogs: '/audit-logs',
  teamsAttendance: createRouteForPath('/teams/attendances'),
  myCommissions: '/accounts/my-commission',
}

export const pageUrlWithoutSidebar = [
  pageUrl.branch,
  pageUrl.branchSetting,
  pageUrl.setupProfile,
  pageUrl.clientAdd,
  pageUrl.settings,
  pageUrl.settingsPaymentTypes,
  pageUrl.accountProfile,
  pageUrl.accountPasswordSecurity,
  pageUrl.bookingWebsite,
  pageUrl.webEditor,
  pageUrl.settingsTaxes,
  pageUrl.settingsServiceCharges,
  pageUrl.clientLoyaltyPoints,
  pageUrl.clientLoyaltyTiers,
  pageUrl.pushNotification,
  pageUrl.settingBlockedTime,
  pageUrl.settingsPrinter,
  pageUrl.myCommissions,
]

export const pageUrlWithoutMargin = [pageUrl.calendar, pageUrl.notifications]
